import { NavLink } from 'react-router';
import { DollarSign, LayoutGrid, Percent } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

interface Pestana {
  a: string;
  etiqueta: string;
  icono: LucideIcon;
}

const PESTANAS: Pestana[] = [
  { a: '/tarifas', etiqueta: 'Tarifas', icono: DollarSign },
  { a: '/tarifas/categorias', etiqueta: 'Categorías', icono: LayoutGrid },
  { a: '/tarifas/mora', etiqueta: 'Interés por mora', icono: Percent },
];

export function PestanasDelTarifario() {
  return (
    <nav
      aria-label="Áreas del tarifario"
      className="mb-6 flex gap-1 overflow-x-auto border-b border-armazon-200"
    >
      {PESTANAS.map(({ a, etiqueta, icono: Icono }) => (
        <NavLink
          key={a}
          to={a}
          end={a === '/tarifas'}
          className={({ isActive }) =>
            [
              'flex shrink-0 items-center gap-2 border-b-2 px-4 py-3 text-[13px] font-semibold uppercase tracking-wide transition-colors',
              isActive
                ? 'border-amber-500 text-armazon-900'
                : 'border-transparent text-armazon-400 hover:text-armazon-600',
            ].join(' ')
          }
        >
          {({ isActive }) => (
            <>
              <Icono
                className={`size-4 shrink-0 ${isActive ? 'text-amber-500' : ''}`}
                aria-hidden
              />
              {etiqueta}
            </>
          )}
        </NavLink>
      ))}
    </nav>
  );
}
